import React from 'react';
import { FaLink } from 'react-icons/fa';
import './LinkEntitiesButton.css';

/**
 * LinkEntitiesButton Component
 * 
 * A standardized button for triggering the entity linking modal.
 * Used across all entity details pages for consistency.
 * 
 * @param {Object} props
 * @param {Function} props.onClick - Click handler
 * @param {string} [props.className] - Additional CSS classes
 * @param {Object} [props.style] - Additional inline styles
 * @param {string} [props.text] - Button text (default: "Link Entities")
 */
const LinkEntitiesButton = ({ onClick, className = '', style = {}, text = 'Link Entities' }) => {
  return (
    <button
      className={`link-entities-button ${className}`}
      onClick={onClick}
      title="Link to Other Entities"
      style={style}
    >
      <FaLink className="link-icon" />
      <span className="link-text">{text}</span>
    </button>
  );
};

export default LinkEntitiesButton;
